/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const snackBarSlice = createSlice({
  name: 'globalSnackbar',
  initialState: {
    snackbars: [],
  },
  reducers: {
    showSnackBar: (state, action) => {
      const { message, severity, duration = 4000 } = action.payload;

      const newSnackbar = {
        id: Date.now() + Math.random(), // Simple unique ID
        setopen: true,
        message,
        severity,
        duration,
      };

      state.snackbars.push(newSnackbar);
    },

    hideSnackBar: (state, action) => {
      const snackbarId = action.payload;
      state.snackbars = state.snackbars.filter(
        (snackbar) => snackbar.id !== snackbarId
      );
    },

    hideAllSnackBars: (state) => {
      state.snackbars = [];
    },
  },
});

export const { showSnackBar, hideSnackBar, hideAllSnackBars } =
  snackBarSlice.actions;
export default snackBarSlice.reducer;
